export default "__VITE_ASSET__C1yU2yri__"